import { createContext, useContext } from 'react'
import type { DraftPayload, TabDef } from '@datahub/shared'

export interface DraftContextValue {
  payload: DraftPayload | undefined
  /** The tabs of the form being filled in, for the name of the tab where a field's rows are entered. */
  tabs: TabDef[]
}

/**
 * The whole draft, for a field whose options come from rows on another tab. It is a
 * context because a field sits two or three components below the page that owns the
 * draft, in a section and in a row drawer, and only a few fields need it.
 */
export const DraftContext = createContext<DraftContextValue>({ payload: undefined, tabs: [] })

export function useDraftContext(): DraftContextValue {
  return useContext(DraftContext)
}
